import { ApplicationActivity } from "../types";
import { ApplicantType } from "shared/types";
import { getFullName } from "shared/utils/get-full-name";
import { ApplicantRole } from "../../../../../../applicant/common/components/ApplicantRole";

interface RemoveCriminalReportViewProps {
  activityItem: ApplicationActivity;
}

export const RemoveCriminalReportView = ({
  activityItem
}: RemoveCriminalReportViewProps) => {
  return (
    <>
      <span className="text-base font-bold text-content-1000">
        Criminal record has been removed by Boom Admin&nbsp;
      </span>
      {activityItem.details.contact ? (
        <span className="text-base text-content-1000">
          for&nbsp;
          {getFullName({
            firstName: activityItem.details.contact.first_name || "",
            middleName: activityItem.details.contact.middle_name || "",
            lastName: activityItem.details.contact.last_name || ""
          })}
          &nbsp;
        </span>
      ) : null}
      <span className="text-base text-content-1000 capitalize">
        (
        <ApplicantRole
          role={activityItem.details.applicant_role as ApplicantType}
        />
        )
      </span>
      <p className="mt-2 text-sm font-normal text-content-400">
        Boom has removed&nbsp;
        {activityItem.details.offense_description || ""}
        &nbsp;from the criminal report. This typically occurs when there is a
        dispute and Boom has sufficient evidence that the record should not be
        surfaced on the report.
      </p>
    </>
  );
};
